import { Component, HostBinding, OnInit, inject } from '@angular/core';

import { WidgetPage } from '@frontend/sports/types/components/widget';
import { LinkListLayout, LinkListPayload } from '@frontend/sports/types/components/widget/types';
import { CleanNavigationComponentVisibilityService } from '@frontend/sports/web/navigation-data-access';
import { WidgetComponent, WidgetContextService } from '@frontend/sports/widget/core/feature';
import { LaunchDarklyService } from '@frontend/vanilla/features/launch-darkly';
import { kebabCase } from 'lodash-es';
import { take } from 'rxjs';

import { LdQuickLinkMode, LdQuickLinkModeFlagKey, QuickLinkItem, toQuickLinkItem } from './quick-links.models';
import { TopBottomSectionLinksComponent } from './top-bottom-section-links/top-bottom-section-links.component';

@Component({
    imports: [TopBottomSectionLinksComponent],
    selector: 'ms-link-list-widget',
    templateUrl: './link-list-widget.component.html',
})
export class LinkListWidgetComponent extends WidgetComponent<LinkListPayload> implements OnInit {
    @HostBinding('class') get className(): string {
        const classes = ['link-list-widget'];

        if (this.title || this.layout === LinkListLayout.MiniCarousel) {
            classes.push('list', 'list-card');
        }

        if (this.layout && this.layout != LinkListLayout.Stacked) {
            classes.push(`link-list-${kebabCase(this.layout)}`);
        }

        return classes.join(' ');
    }

    title: string | undefined;
    layout?: LinkListLayout;
    links: QuickLinkItem[] | undefined;
    smallIcon: boolean;

    private ldFlagValue: LdQuickLinkMode;
    private readonly widgetContext = inject(WidgetContextService);
    private readonly ldService = inject(LaunchDarklyService);

    ngOnInit(): void {
        this.setLDFlagValue();
    }

    constructor(public componentVisibilityService: CleanNavigationComponentVisibilityService) {
        super();
    }

    protected override onData({ title, links, layout }: LinkListPayload): void {
        this.title = title;
        this.links = links?.map(toQuickLinkItem);

        this.filterQuickLinksByLD();

        this.hasData = !!this.links?.length;

        if (layout === LinkListLayout.TilesCarouselSmallIcon) {
            this.smallIcon = true;
            this.layout = LinkListLayout.TilesCarousel;
        } else {
            this.smallIcon = false;
            this.layout = layout;
        }

        this.setWidgetLoaded();
    }

    private setLDFlagValue(): void {
        this.ldService
            .getFeatureFlagValue$(LdQuickLinkModeFlagKey)
            .pipe(take(1))
            .subscribe((value: LdQuickLinkMode) => {
                if (value) {
                    this.ldFlagValue = value;
                    this.filterQuickLinksByLD();
                }
            });
    }

    private filterQuickLinksByLD(): void {
        if (this.links?.length && this.ldFlagValue && this.widgetContext.getContext().page === WidgetPage.HomeLobby) {
            const { enableNavigationQL, enableSheetviewQL } = this.ldFlagValue;

            this.links = this.links.filter(({ quickLinkMode }) => (quickLinkMode === 'sheetview' ? enableSheetviewQL : enableNavigationQL));
        }
    }
}
